export const RefundReason: Record<string, any> = {
  duplicate: 'Duplicate',
  fraudulent: 'Fraudulent',
  requested_by_customer: 'Requested by customer',
}

/**
 * Shortest real card number (Maestro). USIO prices a convenience-fee quote from the card number,
 * and a shorter value is a prefix rather than a card: it comes back as success with a 0.00 fee
 * instead of an error, so the payer is quoted no fee while the charge is priced on the real one.
 * Wait for at least this many digits before asking for the quote.
 */
export const MIN_CARD_DIGITS = 12
